/* esm.sh - react-style-singleton@2.2.3 */
export * from "/*react-style-singleton@2.2.3/esnext/react-style-singleton.mjs";
